export default __webpack_public_path__ + "static/media/organic_90.0cc58c4f.jpg";